import React, { useEffect } from 'react'
import { Box, Button } from '@material-ui/core'
import { SideBar } from '../../../components/side-bar'
import { navLinksProduct } from '../../../services/product'
import {
    options
} from '../../../store/slices'
import { useAppDispatch } from '../../../store'
import { useSelector } from 'react-redux'
import { IOption } from '../../../store/types'
import { FetchCollectionParams, FetchCreatedAtParams } from '../../../services/_common'
import { getIdFromIRI } from '../../../services/_common/utils'
import { DataTable } from '../../../components/dataTable'
import { Link } from 'react-router-dom'
import { ROUTES } from '../../../constants'


export function OptionsPage(): JSX.Element {

    const dispatch = useAppDispatch()
    const fetchStatus = useSelector(options.selectors.fetchStatus)
    const totalItems = useSelector(options.selectors.totalItems)

    useEffect(() => {
        dispatch(options.actions.fetch({pagination: false}))
    }, [])

    return (
        <Box display="flex">
            <SideBar navLinks={navLinksProduct}>
                <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    component={Link}
                    to={ROUTES.PRODUCT_OPTIONS_CREATE}
                >
                    Создать
                </Button>
            </SideBar>
            <DataTable<IOption, FetchCreatedAtParams & FetchCollectionParams>
                title={'Опции моделей'}
                urlPathEdit={'/product/options/edit'}
                fetchProps={{
                    page: 1,
                    perPage: 20,
                }}
                fetchAction={options.actions.fetch}
                selector={options.selectors.selectAll}
                deleteAction={options.actions.remove}
                mappingFunction={(option) => ({
                    id: getIdFromIRI(option.id),
                    name: option.name,
                    description: option.description,
                    values: option.values.map( (value) => value.value ).join(', '),
                })}
                loading={fetchStatus.isFetching}
                columns={[
                    { field: 'id', headerName: 'ID', flex: 1, sortable: false, hide: true },
                    { field: 'name', headerName: 'Название', flex: 1, sortable: true },
                    { field: 'description', headerName: 'Описание', flex: 1, sortable: true },
                    { field: 'values', headerName: 'Значения', flex: 1, sortable: true },
                ]}
                rowCount={totalItems}
            >
            </DataTable>
        </Box>
    )
}